import {Button} from '@/components/ui/button/Button'
import {MessageChatSquareIcon} from '@/components/ui/icon/Icon'
import {useState, useCallback, useEffect} from 'react'
import {ConversationsModal} from '../conversations-modal/ConversationsModal'
import {useSearchParams} from 'react-router-dom'

interface ConversationToggleProps {
    patientId: string
}

const CONVERSATION_ID_PARAM = 'conversation_id'

export const ConversationToggle = ({patientId}: ConversationToggleProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()

    const conversationId = searchParams.get(CONVERSATION_ID_PARAM) ?? null

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true)
    }, [])

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false)

        if (conversationId) {
            const newSearchParams = new URLSearchParams(searchParams)
            newSearchParams.delete(CONVERSATION_ID_PARAM)
            setSearchParams(newSearchParams, {replace: true})
        }
    }, [conversationId, searchParams, setSearchParams])

    const handleClearInitialConversation = useCallback(() => {
        if (conversationId) {
            const newSearchParams = new URLSearchParams(searchParams)
            newSearchParams.delete(CONVERSATION_ID_PARAM)
            setSearchParams(newSearchParams, {replace: true})
        }
    }, [conversationId, searchParams, setSearchParams])

    useEffect(() => {
        if (conversationId && !isModalOpen) {
            setIsModalOpen(true)
        }
    }, [conversationId, isModalOpen])

    return (
        <>
            <Button variant="secondary" shape="square" onClick={handleOpenModal}>
                <MessageChatSquareIcon />
            </Button>
            <ConversationsModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                patientId={patientId}
                initialConversationId={conversationId}
                onClearInitialConversation={handleClearInitialConversation}
            />
        </>
    )
}
